/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react'
// import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import { ERR_EMAIL, ERR_EMAIL_INVALID, NEW_USER_ERROR_INVALID_FIRST_NAME, NEW_USER_ERROR_INVALID_LAST_NAME, ORG_ADMIN_PLACEHOLDER_EMAIL, ORG_ADMIN_PLACEHOLDER_FIRST_NAME, ORG_ADMIN_PLACEHOLDER_LAST_NAME, UPDATE_USER_ERROR_FIRST_NAME, UPDATE_USER_ERROR_LAST_NAME } from 'src/constants/constant';
import { IconButton, TextField,Select, MenuItem, FormControl,InputLabel, FormHelperText } from '@mui/material';
import GradientButton from '../MUICustomButton/GradientButton';
import { useNavigate } from 'react-router-dom';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { getUserById, updateUserData } from 'src/services/userService';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { UPDATE_USER_DELETE_SUBTITLE_1, UPDATE_USER_DELETE_SUBTITLE_2 } from 'src/constants/constant';
import { deleteUserData } from 'src/services/userService';
import MUIModal from '../MUIModal/MUIModal';
import ChangePassword from './ChangePassword';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { getAllRoles } from 'src/services/roleService';
import '../Styles/muiglobal.css';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

interface UserFormInputs {
    "id"?: number;
    "firstName": string;
    "lastName": string;
    "email": string;
    "roleId": number;
    "modifiedBy"?: number;
}

interface Role {
    roleId: number;
    roleName: string;
}

interface RoleApiResponse {
    status: number;
    data: {
        data: Role[];
    };
}

interface PropsType {
    userId?: string;
}

interface UserParamsTyps {
    "id": number;
    "firstName": string;
    "lastName": string;
    "email": string;
    "password": string;
    "isDeleted": boolean;
    "isActive": boolean;
    "createdBy": number;
    "createdOn": string;
    "updatedBy": number;
    "roleId": number;
    "updatedOn": string;
    "deletedBy": number | null;
    "deletedOn": number | null;
}

interface UserDeleteIds {
    "userId": number;
}
interface UserDeleteProps {
    "modifiedBy": number;
    "userLst": UserDeleteIds[];
}

interface ApiResponse {
    status: number;
    data: {
        data: UserParamsTyps[];
    };
}

interface EditApiResponse {
    status: number;
    data: {
        result: number;
        messages: string;
    };
    
}

const validationSchema = Yup.object().shape({
    // firstName: Yup.string().required(UPDATE_USER_ERROR_FIRST_NAME).matches(/^[a-zA-Z0-9\s]*$/, NEW_USER_ERROR_INVALID_FIRST_NAME),
    firstName: Yup.string().required(UPDATE_USER_ERROR_FIRST_NAME).matches(/^[a-zA-Z]+(['-][a-zA-Z]+)*$/, NEW_USER_ERROR_INVALID_FIRST_NAME),
    lastName: Yup.string().required(UPDATE_USER_ERROR_LAST_NAME).matches(/^[a-zA-Z]+(['-][a-zA-Z]+)*$/, NEW_USER_ERROR_INVALID_LAST_NAME),
    email: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),
    roleId: Yup.number().required('Role is required'),

});

const EditUserForm = ({ userId }: PropsType): JSX.Element => {

    const navigate = useNavigate()

    const [userData, setUserData] = useState<UserParamsTyps>()
    const [loading, setLoading] = useState<boolean>(true)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [showDeleteUserModal, setShowDeleteUserModal] = useState<boolean>(false)
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)

    const [showChangePasswordModal, setShowChangePasswordModal] = useState<boolean>(false)
    const [roles, setRoles] = useState< Role[]>([]);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        setValue
    } = useForm<UserFormInputs>({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
    });

    useEffect(() => {
        setLoading(true)
        getUserById(userId).then(
            (res: ApiResponse) => {
                if (res.status === 200) {
                    setUserData(res.data.data[0])
                    setValue("firstName", res.data.data[0].firstName);
                    setValue("lastName", res.data.data[0].lastName);
                    setValue("email", res.data.data[0].email)
                    setValue("roleId", res.data.data[0].roleId)
                }
            }
        )
            .catch(
                error => console.log(error)
            )
            .finally(() => {
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        if(roles.length==0)
        {
            getAllRoles()
            .then(
                (response: RoleApiResponse) => {
                    if (response.status === 200) {
                        const roleListArr: Role[] =[];
                        response.data.data.map((role:Role) => {
                            roleListArr.push(role)
                        })
                        setRoles(roleListArr)
                    }
                }
            )
            .catch(
                error => console.log("Error in fetching users: ", error)
            )
        }
        
    }, [roles]);


    const handleDeleteUser = (): void => {
        setShowDeleteUserModal(true)
    }


    const handleBackClick = (): void => {
        navigate('/settings/manage-users')
    }



    const onSubmit = async (data: UserFormInputs): Promise<void> => {
        data.id = userData?.id;
        data.modifiedBy = 1;
        setIsLoading(true)
        await updateUserData(data)
            .then(
                (res: EditApiResponse) => {
                    if (res.status === 200) {
                        if(res.data.result === 1) {
                            NotificationManager.success("User updated successfully")
                            navigate('/settings/manage-users')
                        } else {
                            if(res.data.messages === "Email address exists in the system") {
                                
                                NotificationManager.error("Email address already exists")
                            }
                        }
                        
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                console.log("done")
                setIsLoading(false)
            })
    }

    const handleDeleteUserClose = (): void => {
        setShowDeleteUserModal(false)
    }

    const handleDeleteUserConfirm = (): void => {
        setIsModalSaveLoading(true)
        const userId: number = userData !== undefined ? userData.id : 0
        const data: UserDeleteProps = {
            "modifiedBy": 1,
            "userLst": [{
                "userId": userId
            }]
        }

        deleteUserData(data)
            .then(
                res => {
                    if (res.status === 200) {
                        NotificationManager.success("User deleted successfully")
                        setIsModalSaveLoading(false)
                        setShowDeleteUserModal(false)
                        navigate('/settings/manage-users')
                    }
                }
            )
            .catch(
                error => console.log("Error in delete user: ", error)
            )
            .finally(() => {
                console.log("done")
                setIsModalSaveLoading(false)
            })
    }

    const handleChangePasswordClick = (): void => {
        setShowChangePasswordModal(true)
    }

    const handleCloseChangePasswordModal = (): void => {
        setShowChangePasswordModal(false)
    }

    return (
        <div  style={{ minHeight: '530px' }}>
            {
                loading ?
                    <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
                    <>
                        <div className="flex justify-between items-center mb-[20px]">
                            <div>
                                <h2 className="text-2xl font-semibold text-title ">User Profile</h2>
                            </div>
                            <div>
                                <OutlineButton onClick={handleBackClick} type='rounded' color='red' width='165px'>
                                    <img src="/assets/images/red-arrow.svg" alt="arrow" width={9} height={8} className="mr-[5px] mt-[1px]" />
                                    Back to user list
                                </OutlineButton>
                            </div>
                        </div>
                        <div className='bg-white p-[20px] shadow-sm rounded-lg mb-[30px] flex justify-between items-center'>
                            <div className='flex items-center'>
                                <div className='mr-[18px] bg-[#CBD1DC] text-[#4D5E71] uppercase w-[62px] h-[62px] rounded-full flex items-center justify-center text-[24px] font-semibold'>
                                    {userData && userData.firstName !== '' ? userData?.firstName?.charAt(0) : ''} {userData && userData.lastName !== '' ? userData?.lastName?.charAt(0) : ''}
                                </div>
                                <div>
                                    <div>
                                        <h1 className='text-muted text-[24px] font-bold'>{userData ? `${userData.firstName} ${userData.lastName}` : ''}</h1>
                                    </div>
                                </div>
                            </div>
                            <div className='flex items-center'>

                                <div className='mr-[15px]'>
                                    <OutlineButton color='gray' onClick={handleChangePasswordClick} >Change Password</OutlineButton>
                                </div>

                                {/* <BootstrapTooltip title="Delete this user from the application database"> */}
                                <div onClick={handleDeleteUser}>
                                    <button className='bg-errorbg border-0 rounded-50 flex items-center justify-center p-0 hover:bg-[#ffaeb2] w-[36px] h-[36px]'><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.4138 4.40863C13.5622 4.12604 10.6935 3.98047 7.83344 3.98047C6.13792 3.98047 4.44241 4.0661 2.74689 4.23737L1 4.40863" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M5.70996 3.54327L5.89835 2.42149C6.03536 1.60799 6.13812 1 7.5853 1H9.82886C11.276 1 11.3874 1.64224 11.5158 2.43006L11.7042 3.54327" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M14.5724 7.11328L14.0158 15.7364C13.9216 17.0808 13.8445 18.1256 11.4554 18.1256H5.95783C3.56869 18.1256 3.49162 17.0808 3.39743 15.7364L2.84082 7.11328" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7.27686 13.418H10.1284" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M6.56592 9.99219H10.8475" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    </button>

                                </div>
                                {/* </BootstrapTooltip> */}
                            </div>
                        </div>
                        <div className='bg-white p-[20px] rounded-lg'>
                            <h5 className='text-[18px] font-bold text-muted mb-[20px]'>Personal Information</h5>

                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    void handleSubmit(onSubmit)(e);
                                }}
                            >
                                <div className='grid gap-5 grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
                                    <div className='w-full relative'>
                                        <div className="mb-[30px]">
                                            <Controller
                                                name="firstName"
                                                control={control}
                                                defaultValue={userData?.firstName}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        label="First Name"
                                                        autoComplete="off"
                                                        placeholder={ORG_ADMIN_PLACEHOLDER_FIRST_NAME}
                                                        // value={field.value}
                                                        error={Boolean(errors.firstName)}
                                                        helperText={errors.firstName?.message}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className='w-full relative'>
                                        <div className="mb-[30px]">
                                            <Controller
                                                name="lastName"
                                                control={control}
                                                defaultValue={userData?.lastName}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        label="Last Name"
                                                        autoComplete="off"
                                                        placeholder={ORG_ADMIN_PLACEHOLDER_LAST_NAME}
                                                        // value={userData?.lastName}
                                                        error={Boolean(errors.lastName)}
                                                        helperText={errors.lastName?.message}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className='w-full relative'>
                                        <div className="mb-[30px]">
                                            <Controller
                                                name="email"
                                                control={control}
                                                defaultValue={userData?.email}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        label="Email"
                                                        autoComplete="off"
                                                        placeholder={ORG_ADMIN_PLACEHOLDER_EMAIL}
                                                        // value={userData?.email}
                                                        error={Boolean(errors.email)}
                                                        helperText={errors.email?.message}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className='w-full relative'>
                                        <div className="mb-[30px]">
                                            <Controller
                                                name="roleId"
                                                control={control}
                                                defaultValue={userData?.roleId}
                                                render={({ field }) => (
                                                    <FormControl fullWidth>
                                                        <InputLabel>Role</InputLabel>
                                                        <Select {...field} label="Role" error={Boolean(errors.roleId)} MenuProps={{ className: 'custom-dropdown' }}>
                                                            {roles.map((role) => (
                                                                <MenuItem key={role.roleId} value={role.roleId}>
                                                                    {role.roleName}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {errors.roleId && (
                                                            <FormHelperText className="MuiFormHelperText-root Mui-error">{errors.roleId.message}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex gap-2 justify-end'>
                                    <OutlineButton color='gray' onClick={() => reset()} width='130px'>Reset</OutlineButton>
                                    <GradientButton type='submit' color='red' onClick={handleDeleteUser} width='130px'>{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                                </div>
                            </form>
                        </div>
                        <BootstrapDialog
                            onClose={handleDeleteUserClose}
                            aria-labelledby="customized-dialog-title"
                            open={showDeleteUserModal}
                            PaperProps={{
                                sx: {
                                    width: '550px',
                                    height: '200px'
                                },
                            }}
                        >
                            <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                                Delete User
                            </DialogTitle>
                            <IconButton
                                aria-label="close"
                                onClick={handleDeleteUserClose}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <DialogContent>
                                <p className='text-14 text-muted'>{UPDATE_USER_DELETE_SUBTITLE_1} <span className='font-semibold'>{`${userData !== undefined ? userData.firstName : ''} ${userData !== undefined ? userData.lastName : ''}`}</span> {UPDATE_USER_DELETE_SUBTITLE_2}</p>
                            </DialogContent>
                            <DialogActions sx={{ background: '#F9F9F9' }}>

                                <OutlineButton color='gray' onClick={handleDeleteUserClose} width='130px'>Cancel</OutlineButton>

                                <GradientButton type='button' color='red' onClick={handleDeleteUserConfirm} width='130px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                            </DialogActions>
                        </BootstrapDialog>

                        <MUIModal openModal={showChangePasswordModal} closeModal={handleCloseChangePasswordModal} title='Change Password' width='25%'>
                            <ChangePassword closeModal={handleCloseChangePasswordModal} userId={userId} />
                        </MUIModal>
                    </>
            }
        </div>
    )
}

export default EditUserForm